import loadable from '@loadable/component';

import PageLoading from '../components/pageLoading';

const Login = loadable(() => import('./login'), { fallback: <PageLoading /> });
const Pricing = loadable(() => import('./pricing'), { fallback: <PageLoading /> });
const RegisterRoute = loadable(() => import('../routes/register'), { fallback: <PageLoading /> });
const ForgotPasswordRoute = loadable(() => import('../routes/forgotPassword'), {
  fallback: <PageLoading />,
});
const GuestSurveyFormRoute = loadable(() => import('../routes/guestSurveyForm'), {
  fallback: <PageLoading />,
});
const IndexPageAppRoute = loadable(() => import('../routes/indexPageApp'), {
  fallback: <PageLoading />,
});
const BoothPointRoute = loadable(() => import('../routes/boothPoint'), {
  fallback: <PageLoading />,
});
const DashboardRoute = loadable(() => import('../routes/dashboard'), { fallback: <PageLoading /> });
const GuestTicketRoute = loadable(() => import('../routes/guestTicket'), {
  fallback: <PageLoading />,
});
const GuestRoute = loadable(() => import('../routes/guest'), {
  fallback: <PageLoading />,
});
const LotteryRoute = loadable(() => import('../routes/lottery'), {
  fallback: <PageLoading />,
});
const Home = loadable(() => import('./home'), { fallback: <PageLoading /> });
const Event = loadable(() => import('./event'), { fallback: <PageLoading /> });
const Site = loadable(() => import('../landingPage/site'), { fallback: <PageLoading /> });
const NotFound = loadable(() => import('./notFound'), { fallback: <PageLoading /> });
const GuestNotFound = loadable(() => import('./guestNotFound'), { fallback: <PageLoading /> });
const Maintenance = loadable(() => import('./maintenance'), { fallback: <PageLoading /> });

export {
  Login,
  Pricing,
  RegisterRoute,
  ForgotPasswordRoute,
  DashboardRoute,
  GuestSurveyFormRoute,
  IndexPageAppRoute,
  BoothPointRoute,
  GuestTicketRoute,
  GuestRoute,
  LotteryRoute,
  Home,
  Event,
  Site,
  NotFound,
  GuestNotFound,
  Maintenance,
};
